import { ChangeDetectionStrategy, Component, computed } from '@angular/core'

import { CmsBlock } from '../cms-block'

@Component({
  selector: 'pai-unknown-block',
  templateUrl: './unknown-block.component.html',
  styleUrls: ['./unknown-block.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  providers: [{ provide: CmsBlock, useExisting: UnknownBlockComponent }],
})
export class UnknownBlockComponent extends CmsBlock<any> {
  readonly __typename = 'Unknown'
  protected readonly dataJsonString = computed(() =>
    JSON.stringify(this.data(), (k, v) => (k && typeof v === 'object' ? '{...}' : v), 2),
  )
}
